module.exports = __webpack_public_path__ + "static/scale-model-of-colee-hammock-park-in-fort-lauderdale-florida-4fc573a9cb07c17051eda1653a0c0190.png";